const ResumeHeading = (props) => {
  return (
    <div className="resume-heading">
      <div className="resume-main-heading">
        <div className="company-info">
          <span>{props.heading ? props.heading : ""}</span>
          <div className="resume-sub-heading">
            {props.subHeading ? props.subHeading : ""}
          </div>
        </div>
        {props.fromDate && props.toDate ? (
          <div className="heading-date">
            {props.fromDate + "-" + props.toDate}
          </div>
        ) : (
          <div></div>
        )}
      </div>
      {props.description && (
        <div className="resume-heading-description">
          <span>{props.description}</span>
        </div>
      )}
    </div>
  );
};

export default ResumeHeading;